<template>
  <div class="com-container">
    <div class="com-chart" ref="trend_ref"></div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      chartInstane: null,
      allData: null, // 从服务器中获取的所有数据
      showChoice: false, // 是否显示可选项
      choiceType: "map", // 显示的数据类型
      titleFontSize: 0, // 指明标题的字体大小
    };
  },
  mounted() {
    this.initChart();
    this.getData();
    window.addEventListener("resize", this.screenAdapter);
    this.screenAdapter();
  },
  destroyed() {
    window.removeEventListener("resize", this.screenAdapter);
  },
  methods: {
    initChart() {
      this.chartInstane = this.$echarts.init(this.$refs.trend_ref, "chalk");
      const initOption = {
        grid: {
          left: "5%",
          top: "10%",
          right: "8%",
          bottom: "3%",
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          show: false,
        },
        xAxis: {
          type: "category",
          axisLabel: {
            color: "#fff",
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#fff",
          },
        },
      };
      this.chartInstane.setOption(initOption);
    },
    async getData() {
      const { data: ret } = await axios.get(
        "https://my.yccngx.com/api/ylt/bcard/platformEnterprise/countByProvince"
      );
      console.log(ret);
      let xData = [];
      let yData = [];

      for (const key in ret.data) {
        xData.push(key);
        yData.push(ret.data[key]);
      }
      this.updateChart(xData, yData);
    },
    updateChart(xData, yData) {
      // 处理数据
      // 类目轴的数据
      const timeArr = xData;
      // y轴的数据 series下的数据
      const seriesArr = {
        name: "数量",
        type: "bar",
        data: yData,
        barWidth: 20,
        itemStyle: {
          color: "#23fffc",
        },
      };
      // 图例的数据
      const dataOption = {
        xAxis: {
          data: timeArr,
        },
        series: seriesArr,
      };
      this.chartInstane.setOption(dataOption);
    },
    screenAdapter() {
      this.titleFontSize = (this.$refs.trend_ref.offsetWidth / 100) * 3.6;
      const adapterOption = {
        legend: {
          itemWidth: this.titleFontSize / 1.5,
          itemHeight: this.titleFontSize / 1.5,
          itemGap: this.titleFontSize,
          textStyle: {
            fontSize: this.titleFontSize / 1.5,
            color: "#fff",
          },
        },
      };
      this.chartInstane.setOption(adapterOption);
      this.chartInstane.resize();
    },
  },
};
</script>

<style lang="less" scoped>
.title {
  position: absolute;
  left: 20px;
  top: 20px;
  z-index: 10;
  color: white;
}
</style>
